import React, { Component } from "react";
import PropTypes from "prop-types";
import { Map, Marker, LayersControl, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import * as types from '../../../constants/ComponentConstants';
import Button from '../Button';
import Legende from './Legende';

class LeafletMap extends Component {
	constructor(props) {
		super(props);
		this.state = {
			center:
				props.markers.length === 1
					&& props.markers[0].lat !== undefined
					&& props.markers[0].long !== undefined ?
					[props.markers[0].lat, props.markers[0].long] : ['51.0132', '4.3554'],  //centre of vlaanderen,
			legendeHovered: false
		};
	}

	componentDidUpdate(prevProps) {
		//todo check warning Do not use setState in componentDidUpdate
		const props = this.props;
		//update the map center only when a new marker is placed on an empty map in edit mode
		if (props.markers.length === 1
			&& props.markers[0].lat !== undefined
			&& props.markers[0].long !== undefined
			&& props.markers[0].lat !== 0
			&& props.markers[0].long !== 0
			&& ((prevProps.markers.length && prevProps.markers[0].lat === undefined && prevProps.markers[0].long === undefined) || props.mapKey !== prevProps.mapKey))
			/* eslint-disable react/no-did-mount-set-state */
			this.setState({
				center: [props.markers[0].lat, props.markers[0].long]
			});
		else if (props.markers.length === 1
			&& props.markers[0].lat === 0
			&& props.markers[0].long === 0
			&& (props.mapKey !== prevProps.mapKey)) {
			/* eslint-disable react/no-did-mount-set-state */
			this.setState({
				center: ['51.0132', '4.3554']
			});
		}
	}

	addRetryFailedTiles(event) {
		const delayInMs = 1000;
		const maxRetries = 3;
		let tile = event.tile;
		tile.retries = tile.retries || 0;
		if (tile.retries < maxRetries) {
			setTimeout(function () {
	
				// eslint-disable-next-line no-self-assign
				tile.src = tile.src; // Reload the tile
				tile.retries += 1;
			}, delayInMs * tile.retries);
		} else {
			console.log(`tile ${tile.src} failed ${tile.retries} times, not retrying.`);
		}
	
	}

	onLegendeHover = () => this.setState({ legendeHovered: true });
	onLegendeUnhover = () => this.setState({ legendeHovered: false });

	render() {
		const originalMarkers = this.props.markers;
		const { onAddMarker, mapKey, onDragend, zoom, legende } = this.props;

		let markersToShow = [];
		originalMarkers.filter(x => x.long && x.lat && x.long != 0 && x.lat != 0).forEach(m => {
			let multipleMarkersOnSameCoordinates = originalMarkers.filter(x => x.long === m.long && x.lat === m.lat).length > 1;
			let markerAlreadyAdded = !!markersToShow.find(mr => mr.long === m.long && mr.lat === m.lat);

			if (!markerAlreadyAdded) {
				let marker = {
					lat: m.lat.toString(),
					long: m.long.toString(),
					size: multipleMarkersOnSameCoordinates || (m.size && m.size.toLowerCase() === "xxl") ? 'xx-large' : 'x-large',
					color: multipleMarkersOnSameCoordinates ?
						types.COLOR_TURQUOISE_DARK : m.color,
					draggable: m.draggable,
					onDragend: onDragend,
					title: m.title
				};
				markersToShow.push(marker);
			}
		});

		const legendeButtonStyle = {
			zIndex: '1000',
			position: 'absolute',
			bottom: '10px',
			left: '10px'
		};

		const markers = markersToShow.map((m, index) => {
			const marker = L.divIcon({
				className: 'fa fa-map-marker ' + (m.size === 'x-large' ? 'marker-large ' : 'marker-xx-large ') + ('marker-' + m.color)
			});

			return <Marker position={[m.lat, m.long]} key={index} icon={marker} draggable={m.draggable} onDragend={m.onDragend} title={m.title ? m.title : null} />;
		});

		const { BaseLayer } = LayersControl;

		const hasOnlyOneMarker = markersToShow.length === 1;
		const state = this.state;
		const center = state.center;
		const legendeHovered = state.legendeHovered;
		const bounds = markersToShow.length === 0 || hasOnlyOneMarker ? null : markersToShow.map(m => [m.lat, m.long]);
		const zoomLevel = markersToShow.length === 0 ? (hasOnlyOneMarker ? zoom ? zoom : 18 : 10) : 13;
		return (<Map onClick={markers && markers.length ? null : onAddMarker} key={mapKey} center={center} zoom={zoomLevel} style={{ width: '100%', height: '600px' }} maxZoom={18} minZoom={8} bounds={bounds} boundsOptions={{ padding: [20, 20] }}>
			<LayersControl position="topright">
				<BaseLayer name="Satelliet">
					<TileLayer
							attribution="Agentschap Digitaal Vlaanderen"
							url="https://geo.api.vlaanderen.be/OMWRGBMRVL/wmts?service=WMTS&request=GetTile&version=1.0.0&layer=omwrgbmrvl&Format=image/png&tilematrixset=GoogleMapsVL&TileMatrix={z}&TileRow={y}&TileCol={x}"
							tms={false}
							tileSize={128}
							zoomOffset={1}
							onTileerror={this.addRetryFailedTiles}
						/>
				</BaseLayer>
				<BaseLayer checked name="Kaart">
					<TileLayer
						attribution="© OpenStreetMap-auteurs"
						url="https://tile.openstreetmap.be/osmbe-nl/{z}/{x}/{y}.png"
					/>
				</BaseLayer>
			</LayersControl>
			<Button small color="#000" style={legendeButtonStyle} className="leaflet-control-layers leaflet-control" text="" children={<div style={{ "color": '#000' }}>Legende</div>} onMouseOver={this.onLegendeHover} onMouseOut={this.onLegendeUnhover} />
			{legendeHovered ? <Legende children={legende} /> : null}
			{markers}
		</Map>);
	}
}

LeafletMap.defaultProps = {
	markers: []
};

LeafletMap.propTypes = {
	markers: PropTypes.arrayOf(PropTypes.object),
	onDragend: PropTypes.func,
	mapKey: PropTypes.string,
	zoom: PropTypes.number,
	size: PropTypes.string,
	onAddMarker: PropTypes.func,
	legende: PropTypes.node
};

export default LeafletMap;
